import { useState, useEffect, useCallback } from "react";

export default function Captcha({ onVerify }) {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [answer, setAnswer] = useState("");
  const [isVerified, setIsVerified] = useState(false);

  const generateCaptcha = useCallback(() => {
    const n1 = Math.floor(Math.random() * 10) + 1;
    const n2 = Math.floor(Math.random() * 10) + 1;
    setNum1(n1);
    setNum2(n2);
    setAnswer("");
    setIsVerified(false);
    if (onVerify) {
      onVerify(false);
    }
  }, [onVerify]);

  useEffect(() => {
    generateCaptcha();
  }, [generateCaptcha]);

  const handleChange = (e) => {
    const value = e.target.value;
    setAnswer(value);
    const correctAnswer = num1 + num2;
    const verified = parseInt(value) === correctAnswer;
    setIsVerified(verified);
    if (onVerify) {
      onVerify(verified);
    }
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
        Verificação de Segurança
      </label>
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        gap: "1rem",
        padding: "1rem",
        background: "var(--border-light)",
        borderRadius: "var(--radius-md)",
        border: isVerified ? "2px solid var(--brand-green)" : "1px solid var(--border)"
      }}>
        <div style={{ 
          fontSize: "1.2rem", 
          fontWeight: 600,
          color: "var(--text-primary)"
        }}>
          {num1} + {num2} = ?
        </div>
        <input
          type="number"
          value={answer}
          onChange={handleChange}
          placeholder="Resposta"
          style={{
            padding: "0.5rem",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-sm)",
            fontSize: "1rem",
            width: "100px",
            textAlign: "center"
          }}
        />
        <button
          type="button"
          onClick={generateCaptcha}
          style={{
            padding: "0.5rem 1rem",
            background: "transparent",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-sm)",
            cursor: "pointer",
            fontSize: "0.9rem",
            color: "var(--text-secondary)"
          }}
          title="Gerar novo CAPTCHA"
        >
          🔄
        </button>
        {isVerified && (
          <span style={{ color: "var(--brand-green)", fontSize: "1.2rem" }}>
            ✓
          </span>
        )}
      </div>
      {answer && !isVerified && (
        <p style={{ color: "#c33", fontSize: "0.85rem", marginTop: "0.5rem" }}>
          Resposta incorreta. Tente novamente.
        </p>
      )}
    </div>
  );
}
